import type { Config } from '@empathyco/playboard-core-domain'
import type { InstanceManagementState, MutationClass } from '../../../models'

export class UpdateServiceConfigMutation implements MutationClass {
  static execute(this: void, state: InstanceManagementState, config: Config): void {
    const indexOfConfig = state.serviceConfigs.findIndex(
      ({ service, instance }: Config) => service === config.service && instance === config.instance,
    )
    if (indexOfConfig >= 0) {
      state.serviceConfigs.splice(indexOfConfig, 1, config)
    }
  }
}
